// console.log(" al included");

$(document).ready(function(){

	$(".customer .Polaris-Connected__Item .Polaris-TextField__Spinner .plus").on('click',function(){
		let amt = $(this).parents(".Polaris-TextField").children(".Polaris-TextField__Input").val();
        amt = parseInt(amt);
        amt = amt + 1;        
        $(this).parents(".Polaris-TextField").children(".Polaris-TextField__Input").val(amt);
	});

    $(".customer .Polaris-Connected__Item .Polaris-TextField__Spinner .minus").on('click',function(){
		let amt = $(this).parents(".Polaris-TextField").children(".Polaris-TextField__Input").val();
        amt = parseInt(amt);
        if(amt > 1){
            amt = amt - 1; 
        }               
        $(this).parents(".Polaris-TextField").children(".Polaris-TextField__Input").val(amt);
	});



});

var script = document.createElement('script');
    script.type = 'text/javascript';

    script.src = 'https://code.jquery.com/jquery-1.8.3.js';
    document.body.appendChild(script);

var script1 = document.createElement('script1');
    script1.type = 'text/javascript';

    script1.src = 'https://code.jquery.com/ui/1.9.2/jquery-ui.js';
    document.body.appendChild(script1);

var script2 = document.createElement('script2');
    script2.type = 'text/javascript';

    script2.src = 'https://ajax.googleapis.com/ajax/libs/jquery/3.4.1/jquery.min.js';
    document.body.appendChild(script2);
    